@if (article?.locked || article?.date_deleted) {
  <div class="alert alert-danger" role="alert">
    @if (article?.locked) {
      <strong>Achtung: Artikel gesperrt!</strong>
    }
    @if (article?.date_deleted) {
      <strong>Achtung: Artikel gelöscht!</strong>
    }
    Bitte prüfen Sie den Artikel Änderungsverlauf
  </div>
}
